import React from 'react';
import { Link } from 'react-router-dom';
import { getPagePath } from '../../utils/appRoutes';
import { ARD_CATEGORY_SEARCH, ARD_SEARCH } from '../../utils/appRoutes.definitions';

export const getCategoryLink = (name, categories, shopName) => (
  <Link
    key={`${name}-category-link`}
    to={`${getPagePath(ARD_CATEGORY_SEARCH, categories)}?webshop=${encodeURIComponent(shopName)}`}
  >
    {name.toLowerCase()}
  </Link>
);

export const getBrandLink = (brand, shopName) => (
  <Link
    key={`${brand}-brand-link`}
    to={`${getPagePath(ARD_SEARCH)}?webshop=${encodeURIComponent(shopName)}&brand=${encodeURIComponent(brand)}`}
  >
    {brand}
  </Link>
);

export const getTopBrandsText = (topBrands, shopInfo, config, intlFull) =>
  topBrands?.length >= 2
    ? intlFull.formatMessage(
        { id: 'shop.topBrandsText' },
        {
          brandsList: intlFull.formatList(
            topBrands
              .slice(0, topBrands.length >= 4 ? topBrands.length - 2 : 2)
              .map(({ key }) => getBrandLink(key, shopInfo.shop_name)),
            { type: 'conjunction' }
          ),
          brandsListAdditional:
            topBrands.length >= 4
              ? intlFull.formatMessage(
                  { id: 'shop.brandsAdditional' },
                  {
                    brands: intlFull.formatList(
                      topBrands.slice(topBrands.length - 2).map(({ key }) => getBrandLink(key, shopInfo.shop_name)),
                      { type: 'conjunction' }
                    ),
                  }
                )
              : '',
        }
      )
    : '';

export const getSubCategoryFullSlug = (category) => {
  const subcategory = category.parent ? getSubCategoryFullSlug(category.parent.buckets[0]) + '/' : '';
  return `${subcategory}${category.slug}`;
};

export const imageFix = (shopInfo) =>
  (shopInfo?.shop_logo ? shopInfo?.shop_logo?.replace('163x74.png', '233x100.png') : '') || '';
